export enum TaskType {
  Approval = 'approval',
  Review = 'review',
  FollowUp = 'follow_up',
  Information = 'information',
  Custom = 'custom'
}

export enum TaskStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Overdue = 'overdue'
}

export enum TaskPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical'
}

export interface TaskAssignee {
  id: string;
  name: string;
  email?: string;
  avatar?: string;
}

export interface TaskRecord {
  id: string;
  type: 'session' | 'template' | 'person' | 'company';
  title: string;
  url?: string;
}

export interface Task {
  id: string;
  title: string;
  description?: string;
  type: TaskType;
  status: TaskStatus;
  priority: TaskPriority;
  
  // Assignment
  assignedTo?: TaskAssignee;
  assignedBy?: TaskAssignee;
  
  // Timing
  createdAt: string;
  updatedAt: string;
  dueDate?: string;
  completedAt?: string;
  
  // Relations
  relatedRecord?: TaskRecord;
  sessionId?: string;
  templateId?: string;
  personId?: string;
  companyId?: string;
  
  // Approval-specific fields
  approvalStatus?: 'pending' | 'approved' | 'rejected';
  approvalNotes?: string;
  
  // Metadata
  tags?: string[];
  notes?: string;
  attachments?: TaskAttachment[];
}

export interface TaskAttachment {
  id: string;
  name: string;
  url: string;
  type: string;
  size: number;
  uploadedAt: string;
}

export interface CreateTaskRequest {
  title: string;
  description?: string;
  type: TaskType;
  priority?: TaskPriority;
  assignedToId?: string;
  dueDate?: string;
  relatedRecord?: TaskRecord;
  sessionId?: string;
  templateId?: string;
  personId?: string;
  tags?: string[];
}

export interface UpdateTaskRequest {
  id: string;
  title?: string;
  description?: string;
  status?: TaskStatus;
  priority?: TaskPriority;
  assignedToId?: string;
  dueDate?: string;
  notes?: string;
  tags?: string[];
}

export interface TaskFilters {
  status?: TaskStatus[];
  type?: TaskType[];
  priority?: TaskPriority[];
  assignedTo?: string[];
  createdBy?: string[];
  dueDate?: {
    from?: string;
    to?: string;
  };
  tags?: string[];
  search?: string;
}

export interface TaskGrouping {
  field: 'status' | 'assignee' | 'dueDate' | 'priority' | 'type' | 'createdDate';
  order: 'asc' | 'desc';
}

export interface TaskListResponse {
  tasks: Task[];
  totalCount: number;
  hasMore: boolean;
}

// Quick action types for task creation (inspired by Attio)
export interface QuickTaskAction {
  type: 'create_task';
  context?: {
    recordId?: string;
    recordType?: string;
    recordTitle?: string;
  };
}
